import { render, staticRenderFns } from "./EventTrends.vue?vue&type=template&id=305be86a&scoped=true"
import script from "./EventTrends.vue?vue&type=script&lang=js"
export * from "./EventTrends.vue?vue&type=script&lang=js"
import style0 from "./EventTrends.vue?vue&type=style&index=0&id=305be86a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305be86a",
  null
  
)

export default component.exports